/*
 * Public API Surface of angular-feather
 */

export { FeatherComponent } from './lib/feather.component';
export { FeatherModule } from './lib/feather.module';
